export default [
  {
    path: 'product-feeds-v2',
    name: 'website.product-feeds-v2',
    component: () => import('@/views/website/feeds/product-feeds'),
  },
  {
    path: 'product-feeds-v2/create',
    name: 'website.product-feeds-v2.create',
    component: () => import('@/views/website/feeds/product-feeds/Create'),
  },
  {
    path: 'product-feeds-v2/update/:id',
    name: 'website.product-feeds-v2.update',
    props: true,
    component: () => import('@/views/website/feeds/product-feeds/Update'),
  },
];
